import React from 'react';
import TableBody from '@material-ui/core/TableBody';
import { bodyStyles, StyledTableCell, StyledTableRow } from './styles';
import { ApplicationsTableBodyProps } from '€lib/types/ApplicationsTableTypes';

export default function ApplicationsTableBody({
    rows,
    page,
    getTableBodyProps,
    prepareRow,
}: ApplicationsTableBodyProps) {
    const classes = bodyStyles();

    return (
        <TableBody {...getTableBodyProps()}>
            {page.map(row => {
                prepareRow(row);
                return (
                    <StyledTableRow {...row.getRowProps()}>
                        {row.cells.map(cell => {
                            return (
                                <StyledTableCell scope="row" key={cell.id} {...cell.getCellProps()}>
                                    {cell.render('Cell')}
                                </StyledTableCell>
                            );
                        })}
                    </StyledTableRow>
                );
            })}
            {rows.length === 0 && (
                <StyledTableRow>
                    <StyledTableCell colSpan={6} className={classes.emptyCell}>
                        No data found
                    </StyledTableCell>
                </StyledTableRow>
            )}
        </TableBody>
    );
}
